<template>
  <v-card elevation="0" v-if="user.loginType === 'EMAIL'">
    <v-card-title>Change Password</v-card-title>
    <v-card-text>
      <v-form style="width: 350px;">
        <v-text-field
          label="Old Password"
          name="oldPassword"
          type="password"
          v-model="oldPassword"
          outlined
          dense
        />
        <v-text-field
          label="New Password"
          name="newPassword"
          type="password"
          v-model="newPassword"
          outlined
          dense
        />
        <v-text-field
          label="New Password Repeat"
          name="newPasswordRepeat"
          type="password"
          v-model="newPasswordRepeat"
          outlined
          dense
        />
        <div>
          <small
            style="color: #696969"
          >Your new password must have at least one digit, one alphanumeric and one uppercase character.</small>
        </div>
        <v-btn
          color="primary"
          class="mt-2"
          @click="tryChangePassword()"
          :loading="passwordChanging"
          elevation="0"
          small
        >Change Password</v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      newPasswordRepeat: "",
      passwordChanging: false
    };
  },
  computed: {
    ...mapState(["user"])
  },
  methods: {
    ...mapActions({
      changePassword: "settings/changePassword"
    }),
    async tryChangePassword() {
      if (!this.oldPassword || !this.newPassword || !this.newPasswordRepeat)
        return;
      if (this.newPassword !== this.newPasswordRepeat) {
        alert("New password should match with repeat");
        return;
      }
      this.passwordChanging = true;
      await this.changePassword({
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      });
      this.passwordChanging = false;
    }
  }
};
</script>